import type { CreateProjectDocumentationBody, ProjectPathParams } from '@si/types';
import { post } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

type Params = ProjectPathParams & CreateProjectDocumentationBody;

export function useCreateProjectDocumentation() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: Params) =>
      post({
        url: `/projects/${params.projectId}/documentation`,
        body: { ...params },
      }),
    onSuccess: (_, variables) =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectDocumentation(variables.projectId),
      }),
  });

  const createProjectDocumentation = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    createProjectDocumentation,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
